import { app } from '@/main';

export const password = {
  getMessage: (field, params, data) => {
    return `Password must contain at least 5 characters`;
  },
  validate: value => {
    return value.length > 4;
  }
};

export const fullName = {
  getMessage: (field, params, data) => {
    return `Please inform your full name.`;
  },
  validate: value => {
    return value.length > 2;
  }
};

export const checkEqual = {
  getMessage: () => {
    return String(app.$t('general.retype_password'));
  },
  validate: (value, args) => {
    if (args.length == 0) {
      return false;
    }

    return value === args[0];
  }
};
export const EIN = {
  getMessage: () => {
    return 'EIN not valid';
  },
  validate: value => {
    return /^[1-9]\d?-\d{7}$/.test(value);
  }
};
export const noRequired = {
  getMessage: () => {
    return '';
  },
  validate: () => {
    return true;
  }
};

export const simplePhone = value => value.length > 14;
